<template>
  <div class="tender-activity-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-input placeholder="请输入用户Id" v-model.number="params.userId" clearable size="small" @change="winRecordPage()" class="param-input"></el-input>
      <el-input placeholder="请输入用户昵称" v-model="params.userName" clearable size="small" @change="winRecordPage('status')" class="param-input"></el-input>   
      <el-input placeholder="请输入模特id" v-model.number="params.modelId" clearable size="small" @change="winRecordPage('status')" class="param-input"></el-input>         
      <el-button type="primary" size="small" @click="winRecordPage('status')">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="userId" label="用户id" align="center" min-width="220" fixed show-overflow-tooltip>
        <template slot-scope="scope">
          <span> {{scope.row.userId  || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userName" min-width="160" label="用户昵称" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span> {{scope.row.userName ||'未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="modelId" label="模特id" align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{scope.row.modelId}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="期号" align="center" min-width="200">
        <template slot-scope="scope">
          <span> {{scope.row.date | changeMd}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="operating" label="操作" align="center" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="Action('edit',scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5,10,15,20]" :current-page="params.page" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" background @size-change="changeSize" :total="total" v-if="total > 10" @current-change="changeCurrent"></el-pagination>
  

  </div>
</template>
<script>


import API from '@/api'
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: '',
      params: {
        page: 1,
        pageSize: 10,
      }
    }
  },
  created() {
    this.winRecordPage()
  },
  methods: {
    // 请求获奖记录列表
    winRecordPage(type) {
      if (type==='status') {
        this.params.page = 1
      }
      this.loading = true
      API.winRecordPage(this.params).then(res => {
        if (res.code === 200 && res.data.data) {
          this.tableData = res.data.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.loading = false
      })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size
      this.params.page = 1
      this.winRecordPage()
    },
    // 当前页发生变化触发
    changeCurrent(page) {
      this.params.page = page
      this.winRecordPage()
    },
    // // 编辑活动成功回掉
    // handlerCodeList() {
    //   this.winRecordPage()
    // },


  }
}
</script>
<style scoped>
</style>
